import { isIOS } from './index';
import { callApp } from '@ifeng/callapp';
import { isWeChat } from './index';
/* eslint-disable no-unused-expressions */
// export const fixStateBar = (function fixStateBar() {
//     if (!window.grounds || !window.grounds.getStatusBarHeight) return 0;
//
//     // IOS直接获取高度即可
//     const stateBarHeight = isIOS
//         ? window.grounds.getStatusBarHeight()
//         : window.grounds.getStatusBarHeight() / window.devicePixelRatio;
//
//     return stateBarHeight;
// })();

const type = {
    camera: 'camera', // 相机
    voice: 'voice', // 麦克风
    storage: 'storage', // 存储（相册）
    location: 'location', // 定位
};

// const requestH5NeedPermission = window.grounds?.requestH5NeedPermission;
// const hasH5NeedPermission = window.grounds?.hasH5NeedPermission;
// // 请求相机权限
// const requestCameraPermission = (callBack = '') =>
//     requestH5NeedPermission && window.grounds.requestH5NeedPermission(type.camera, '相机申请权限', callBack);
// // 请求麦克风权限
// const requestVoicePermission = (callBack = '') =>
//     requestH5NeedPermission && window.grounds.requestH5NeedPermission(type.voice, '麦克风申请权限', callBack);
// // 请求存储（相册）权限
// const requestStoragePermission = (callBack = '') =>
//     requestH5NeedPermission && window.grounds.requestH5NeedPermission(type.storage, '存储(相册)申请权限', callBack);
// // 请求定位权限
// const requestLocationPermission = (callBack = '') =>
//     requestH5NeedPermission && window.grounds.requestH5NeedPermission(type.location, '定位申请权限', callBack);
// // 获取相机权限
// const cameraPermission = () => hasH5NeedPermission && window.grounds?.hasH5NeedPermission(type.camera);
// // 获取麦克风权限
// const voicePermission = () => hasH5NeedPermission && window.grounds?.hasH5NeedPermission(type.voice);
// // 获取存储（相册）权限
// const storagePermission = () => hasH5NeedPermission && window.grounds?.hasH5NeedPermission(type.storage);
// // 获取定位权限
// const locationPermission = () => hasH5NeedPermission && window.grounds?.hasH5NeedPermission(type.location);
//
// // 暴露出去获取媒体资源及请求媒体权限API
// export const permisson = {
//     cameraPermission,
//     voicePermission,
//     storagePermission,
//     locationPermission,
//     requestCameraPermission,
//     requestVoicePermission,
//     requestStoragePermission,
//     requestLocationPermission,
// };

// 判断是否在端内,开发环境置为true，便于开发
export const isClient = false;

const PID_CONFIG = {
    // 渠道名称：内推-圈子社区-01   备注：顶通
    '8865': {
        kind: 'inter_qzsq01',
        download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1501524666934',
        downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8865',
    },
    // 渠道名称：内推-圈子社区-02   备注：内容分享
    '8866': {
        kind: 'inter_qzsq02',
        download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1501523787684',
        downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8866',
    },
    // 渠道名称：内推-圈子社区-03   备注：内容评论
    '8867': {
        kind: 'inter_qzsq03',
        download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1501523998511',
        downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8867',
    },
    // 渠道名称：内推-圈子社区-04   备注：打开APP
    '8868': {
        kind: 'inter_qzsq04',
        download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1501524773329',
        downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8868',
    },
};

// 拉起端内app
/**
 *
 * @param {string} channelId '8865': 顶通| '8866': 内容分享 | '8867': 内容评论 | '8868': 打开APP
 * @returns
 */
// export const arouseClient = channelId => {
//     if (!isClient) {
//         callApp({
//             docType: 'web',
//             pid: window.location.href,
//             ...(PID_CONFIG[channelId] || {}),
//         });
//     }
//
//     return isClient;
// };
// 获取当前定位信息
// export const getGroundsLocation = async () => {
//     const callbackName = `getLocation_${Date.now()}`;
//
//     const res = await new Promise((resolve, reject) => {
//         window[callbackName] = jsonstr => {
//             resolve(JSON.parse(jsonstr));
//         };
//
//         window.grounds?.getLocation && window.grounds?.getLocation(callbackName);
//     });
//
//     delete window[callbackName];
//
//     return res;
// };

// 获取键盘高度
// export const getKeyboardHeight = async () => {
//     const callbackName = `getHeight_callback_${Date.now()}`;
//
//     const res = await new Promise(resolve => {
//         window[callbackName] = jsonstr => {
//             resolve(JSON.parse(jsonstr));
//         };
//         window.grounds?.on && window.grounds?.on('getKeyboardHeight', callbackName);
//     });
//
//     delete window[callbackName];
//
//     return res;
// };

// 关闭当前webview
// export const closeApi = () => {
//     // 微信浏览器回退
//     if (isWeChat()) {
//         history.go(-1);
//
//         return;
//     }
//     if (!isClient) {
//         return;
//     }
//     if (window.grounds?.close) {
//         window.grounds?.close();
//     } else {
//         window.close();
//     }
// };

// 最大化，最大化之后需要我们自定义头部
// export const maximization = () => {
//     if (isIOS) {
//         window.grounds?.setMultiToolBarHidden && window.grounds.setMultiToolBarHidden(true);
//     }
//     window.grounds?.maximization && window.grounds.maximization();
// };

//const getUserInfo = window.grounds?.getUserInfo && window.grounds.getUserInfo();

// 获取用户头像
// const getUserImage = () => {
//     return getUserInfo?.getUserImage && window.grounds.getUserInfo().getUserImage();
// };
// // 获取用户昵称
// const getNickname = () => {
//     return getUserInfo?.getNickname && window.grounds.getUserInfo().getNickname();
// };
// // 获取用户token
// const getToken = () => {
//     return getUserInfo?.getToken && window.grounds.getUserInfo().getToken();
// };
//
// // 获取用户uid
// const getGuid = () => {
//     return getUserInfo?.getGuid && window.grounds.getUserInfo().getGuid();
// };

// 拉起用户登录
// export const userLogin = () => {
//     window.grounds?.userLogin && window.grounds.userLogin();
// };

// export const getUserInfoApi = {
//     getUserImage, // 获取用户头像
//     getNickname, // 获取用户昵称
//     getToken, // 获取用户token
//     getGuid, // 获取用户uid
// };

// 禁止默认收拾区域，三个参数分别代表左上顶点纵坐标，左下顶点纵坐标， 屏幕高度
export const setH5PageTouchArea = (top = 0, bottom, height) => {
    if (typeof (window) ===undefined) {
        window = {}
    }
    window.grounds?.setH5PageTouchArea && window.grounds.setH5PageTouchArea(top, bottom, window.innerHeight);
};

export const setNoSlideArea = area => {
    if (typeof (window) ===undefined) {
        window = {}
    }
    const data = JSON.stringify({
        area,
        totalHeight: window.innerHeight,
    });

    window?.grounds?.setNoSlideArea && window?.grounds.setNoSlideArea(data);
};

export const getFinnalPath = () => {
    if (typeof (window) ===undefined) {
        window = {}
    }
    try {
        const pathname = window.location?.pathname?.split('/');

        Array.isArray(pathname) && pathname?.pop();

        return pathname?.join('/');
    } catch (e) {
        console.log(e);
    }
};

// 跳转页面
export const dispatchPage = ({ type = 'web', url, newWebview = true, needOrigin = true }) => {
    if (typeof (window) ===undefined) {
        window = {}
    }
    try {
        const finnalUrl = `${needOrigin ? window.location.origin + getFinnalPath() : ''}${url}${
            url?.indexOf('?') > -1 ? '&' : '?'
        }${newWebview ? 'isFull=0&immersion=true&ifengsp=1' : ''}`;

        window.grounds?.dispatch ? window.grounds.dispatch(type, finnalUrl) : window.open(finnalUrl); // 方便PC端测试
    } catch (e) {
        console.log(e);
    }
};

/**
 * 获取网络当前状况
 */

// export const getNetWork = async () => {
//     if (!window?.grounds?.on) {
//         return;
//     }
//     const callbackName = `getNetWork${Date.now()}`;
//
//     const res = await new Promise((resolve, reject) => {
//         window[callbackName] = netValue => {
//             resolve(netValue);
//         };
//
//         window.grounds.on('networkchange', callbackName);
//     });
//
//     delete window[callbackName];
//
//     return res;
// };

/**
 * 分享
 *
 */
/**
 *
 * @param {string} shareurl 分享链接
 * @param {string} title 标题
 * @param {string} desc 简介
 * @param {string} thumbnail 分享图片
 * @param {string} documentId 分享id
 */
// export const nativeShare = (shareurl, title, desc, thumbnail, documentId) => {
//     if (!arouseClient('8866')) return;
//     window.grounds?.openShare && window.grounds?.openShare(shareurl, title, desc, thumbnail, documentId);
// };

export const setPageNoActiveListener = callback => {
    // 安卓 webview 无法监听 visibilitychange 事件
    // const isAndroid = /android/i.test(window.Grounds?.getDeviceInfo && window.Grounds.getDeviceInfo().getOs());
    //
    // if (window.grounds && isAndroid) {
    //     // window.grounds.on('active', 'historyTask_reGetData');
    //     window.grounds.on('onExit', 'historyTask_reGetData');
    //     window.historyTask_reGetData = () => callback();
    // }

        document.addEventListener('visibilitychange', e => {
            if (document.visibilityState === 'hidden') {
                callback();
            }
        });

};
